<template>
  <b-form id="KontaktNeuAnlegen" @submit.prevent="kontaktSpeichern()">
    <b-form-row>
      <b-col cols="12" md="6">
        <b-form-group id="vorname-group" label="Vorname *" label-for="vorname">
          <b-form-input
            id="vorname"
            v-model="neuerKontakt.vorname"
            type="text"
            :state="vornameState"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group id="name-group" label="Name *" label-for="name">
          <b-form-input
            id="name"
            v-model="neuerKontakt.name"
            type="text"
            :state="nameState"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row>
      <b-col cols="12" sm="6">
        <b-form-group id="email-group" label="E-Mail Adresse" label-for="email">
          <b-form-input
            id="email"
            v-model="neuerKontakt.email"
            type="email"
            :state="emailState"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6">
        <b-form-group id="mobil-group" label="Mobilnummer" label-for="mobil">
          <b-form-input id="mobil" v-model="neuerKontakt.mobil" type="text" :state="mobilState"></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>

    <hr />

    <b-row>
      <b-col>
        <b-form-group>
          <b-form-checkbox
            id="favorit"
            v-model="neuerKontakt.favorit"
            name="favorit"
            value=1
            unchecked-value=0
          >Zu Favoriten hinzufügen</b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col>
        <b-button
          type="submit"
          variant="warning"
          class="float-right"
          v-bind:disabled="!neuerKontaktValidation"
        >Neuen Kontakt speichern</b-button>
      </b-col>
    </b-row>
    <p class="text-left small">mit * gekennzeichnete Felder sind Pflichtfelder</p>
  </b-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "KontaktNeuAnlegen",
  computed: {
    ...mapGetters(["kontakteStatus"]),
    vornameState() {
      if (this.neuerKontakt.vorname === "") return null;

      return this.neuerKontakt.vorname.length > 2 ? true : false;
    },
    nameState() {
      if (this.neuerKontakt.name === "") return null;

      return this.neuerKontakt.name.length > 2 ? true : false;
    },
    emailState() {
      if (this.neuerKontakt.email === "") return null;

      return this.emailRegex.test(this.neuerKontakt.email) ? true : false;
    },
    mobilState() {
      if (this.neuerKontakt.mobil === null || this.neuerKontakt.mobil === "") return null;

      return this.neuerKontakt.mobil.length > 2 ? true : false;
    },
    neuerKontaktValidation() {
      return this.vornameState && this.nameState
        ? true
        : false;
    }
  },
  methods: {
    ...mapActions(["createKontakt"]),
    kontaktSpeichern() {
      this.createKontakt(this.neuerKontakt).then(() => {
        const toastData = {
          title: "",
          msg: "Ein neuer Kontakt wurde angelegt.",
          variant: "success"
        };

        if (this.kontakteStatus.errMsg) {
          toastData.title = "Es ist etwas schief gelaufen.";
          toastData.msg = this.kontakteStatus.errMsg;
          toastData.variant = "danger";
        }

        this.$emit("creatContactToast", toastData);

        if (!this.kontakteStatus.errMsg) {
          this.$bvModal.hide(`kontaktAnlegen`);
        }
      });
    }
  },
  data() {
    return {
      emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
      neuerKontakt: {
        vorname: "",
        name: "",
        email: "",
        mobil: "",
        favorit: 0
      }
    };
  }
};
</script>

<style>
</style>